import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { isApparel } from "../helpers/productHelpers";
import { getProductType } from "../redux/creators/threekitCreators";
import OptionLabel from "./OptionLabel";

export default function VariantColorOption({
  option,
  selected,
  handleProductChange
}) {
  const { selectedProduct, productType } = useSelector((state) => ({
    selectedProduct: state.threekit.selectedProduct,
    productType: getProductType(state),
  }));

  /*
   * Get class names for colors
   * Must include color name for css
   * Also includes selected and/or disabled
   */
  const getClassNames = (value) => {
    const colorName = value.split(" ")[0];
    const selectedClass = selected == value ? "selected" : "";
    const disabledClass = isColorSoldOut(value) ? "color-disabled" : "";
    return "option-circle " + colorName + " " + selectedClass + " " + disabledClass;
  }

  // If variant is sold out
  const isColorSoldOut = (value) => {
    let soldOutVariants = selectedProduct.variants.filter((variant) => !variant.available);

    // If apparel, filter variants for only current size
    if (isApparel(productType)) {
      const selectedSize = selectedProduct.option1;
      soldOutVariants = soldOutVariants.filter((variant) => variant.option1 == selectedSize);
    }

    let isSoldOut = false;
    soldOutVariants
      .map((variant) => variant.options)
      .forEach((options) => {
        if (options.includes(value)) {
          isSoldOut = true;
        }
      });
    return isSoldOut;
  }

  return (
    <ColorContainer>
      <OptionLabel label={option.name} />
      <div id="optionCircles">
        {option.values.map((value) => {
          return (
            <div
              key={"option_" + value}
              className={`option-circle-container ${productType}`}
            >
              <div key={"tooltip_" + value} className="tooltip-inner">
                {value}
              </div>
              <label>
                <input
                  type="radio"
                  key={value}
                  value={value}
                  aria-label={value}
                  className={getClassNames(value)}
                  disabled={isColorSoldOut(value)}
                  onClick={() => handleProductChange(value, "Color")}
                />
              </label>
            </div>
          );
        })}
      </div>
    </ColorContainer>
  );
}

const ColorContainer = styled.div`
  width: 100%;
  padding-bottom: 24px;
`;
